import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="searchbox-utility">
  <slot></slot>
</div>
`

class NavHeaderSearchBoxUtility extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderSearchBoxUtility connectedCallback', this)

  }
}

customElements.define('ts-navheader-searchbox-utility', NavHeaderSearchBoxUtility)
